/**
 * プラン
 */

/**
 * 無料プラン
 */
export const FREE = 0;
/**
 * スタンダードプラン
 */
export const SAFETY = 1;
/**
 * エンタープライズプラン
 */
export const SAFETY_X = 2;
/**
 * スタンダードプランの最大登録可能人数
 */
export const MAX_CAPACITY_COUNT = 1000;
